<template>
    <div>
        <div class="NavS">
            <!-- 循环渲染导航方块 -->
            <div class="NavsItem" v-for="i in Navs" :key="i.path" @click="GoPage(i)">
                <div class="NavsItemIcon">
                    <i class="iconfont" :class="i.icon"></i>
                </div>
                <div class="NavsItemTxt">{{i.system_name}}</div>
            </div>
        </div>
        <div class="Out" @click="OutLogin">退出</div>
    </div>

</template>

<script>
    export default {
        data() {
            return {
                Navs: [],
            };
        },
        mounted() {
            this.GetSystem();
        },
        methods: {
            GetSystem() {
                // this.$get("/api/auth/getAll").then(res => {
                //     if (res && res.data) {
                //         this.Navs = res.data;
                //     }
                // }).catch(err => {
                //     console.error("获取系统列表失败：", err);
                // })
                this.$get('/api/expert_portal/systemlist').then(res=>{
                    if(res){
                        this.Navs = res.data.list;
                    }
                }).catch(err => {
                    console.error("获取系统列表失败：", err);
                })
            },
            
            GoPage(i) {
                sessionStorage.setItem('ThisSysTem', i.system_code);
                setTimeout(() => {
                    this.$router.push({
                        path: "/MobileList"
                    });
                }, 50)
            },
            OutLogin() {
                var _this = this;
                this.$dialog({
                    title: "提示？",
                    content: "确认退出吗?",
                    onOkBtn(event) { //确定按钮点击事件
                        this.$post("/api/auth/logout").then(res => {
                            if (res) {
                                this.close(); //关闭对话框
                                _this.$router.push('/MobileLogin');
                            }
                        })
                    },
                });
            }
        }
    }
</script>

<style scoped>
    .NavS {
        width: 92%;
        max-width: 500px;
        /* 限制最大宽度，大屏手机不显得过宽 */
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        padding: 20px 0;
    }

    .NavsItem {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: #f8f9fa;
        border-radius: 12px;
        padding: 24px 0;
        transition: all 0.2s ease;
    }

    .NavsItem:active {
        background-color: #e9ecef;
        transform: scale(0.98);
    }

    .NavsItemIcon {
        border-radius: 8px;
        /* 小圆角方块，更美观 */
        border: 2px solid #095b95;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        margin: 0 auto 12px;
        /* 调整与文字的间距 */
    }

    .NavsItemIcon .iconfont {
        font-weight: 700;
        color: #095b95;
        font-size: 26px;
        /* 适配手机端图标大小 */
    }

    .NavsItemTxt {
        text-align: center;
        font-weight: 500;
        /* 手机端无需过粗，中等粗细更舒适 */
        font-size: 15px;
        /* 适配手机端文字大小 */
        color: #3c3c3c;
        width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .Out {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: 40%;
        margin: 10px auto 10px;
        background: #221714;
        padding: 7px 0;
        text-align: center;
        color: #fff;
        border-radius: 10px;
    }
</style>